import { Files, FolderArchive } from 'lucide-react';

import { AssetTypeEnum } from 'src/graphql/schema';
import { logoMap, renderLogo } from 'src/utils/renderLogo';

type Props = {
  type: AssetTypeEnum;
  provider?: string;
};

const AssetTypeIcon = ({ type, provider }: Props) => {
  let Icon: React.ElementType | null = null;

  if (type === AssetTypeEnum.SecureUpload) Icon = Files;
  if (type === AssetTypeEnum.RepoUpload) Icon = FolderArchive;
  if (type === AssetTypeEnum.OauthRepo || type === AssetTypeEnum.CustomRepo)
    Icon = renderLogo(provider as keyof typeof logoMap);

  return Icon ? <Icon className="size-5 shrink-0" /> : null;
};

export default AssetTypeIcon;
